/* eslint react/jsx-key: off */
import React from 'react';
import PropTypes from 'prop-types';
import { Show, SimpleShowLayout, TextField, DateField, ReferenceField } from 'react-admin'; // eslint-disable-line import/no-unresolved


const StockOutShow = ({ permissions, ...props }) => (
    <Show {...props}>
        <SimpleShowLayout>
            <ReferenceField label="resources.stockouts.fields.product" source="productId" reference="products">
                <TextField source="name" />
            </ReferenceField>
            <TextField source="qty" />
            <DateField source="stockOutDate" />
            <ReferenceField label="resources.stockouts.fields.stock_out_request" source="stockOutRequestId" reference="stockoutrequests">
                <TextField source="id" />
            </ReferenceField>
            <ReferenceField label="resources.stockouts.fields.user" source="appUserId" reference="appusers">
                <TextField source="username" />
            </ReferenceField>
            <ReferenceField label="resources.stockouts.fields.team" source="teamId" reference="teams">
                <TextField source="name" />
            </ReferenceField>

        </SimpleShowLayout>
    </Show>
);

StockOutShow.propTypes = {
    location: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
    permissions: PropTypes.string,
};

export default StockOutShow;
